const mutations = {
  
    SET_INFO_GRADE (state, status) {

        state.infoGrade = status

    },
    SET_DISCIPLINA_GRADE (state, status) {

        state.disciplinaGrade = status

    },
}

export default mutations